// extracted by mini-css-extract-plugin
module.exports = {"Paragraph__root":"_4T1H","Paragraph__title":"tHEm"};